// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3faJY","selected":"Chip_selected__1VWnj"};